import { useFormikContext } from 'formik'
import { FC, useEffect } from 'react'

import { ToggleSwitch } from '@components/Form/ToggleSwitch'

import PromiseUtil from '@/utils/PromiseUtil'

import { PatientRelativeFormShape } from '../PatientRelativeForm'

type Props = {
  name: string
}

const PatientRelativeFormLivingToggleSwitch: FC<Props> = ({ name }) => {
  const { values, setFieldValue } = useFormikContext<PatientRelativeFormShape>()

  const handleOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(name, e.target.checked)

    if (e.target.checked) {
      setFieldValue('living_country', values.nric_country)
      setFieldValue('living_address_1', values.nric_address_1)
      setFieldValue('living_address_2', values.nric_address_2)

      await PromiseUtil.delay(50)
      setFieldValue('living_first_level_administrative_division_id', values.nric_first_level_administrative_division_id)

      await PromiseUtil.delay(50)
      setFieldValue(
        'living_second_level_administrative_division_id',
        values.nric_second_level_administrative_division_id
      )

      await PromiseUtil.delay(50)
      setFieldValue('living_third_level_administrative_division_id', values.nric_third_level_administrative_division_id)

      await PromiseUtil.delay(50)
      setFieldValue(
        'living_fourth_level_administrative_division_id',
        values.nric_fourth_level_administrative_division_id
      )

      setFieldValue('living_postal_code', values.nric_postal_code)
    }
  }

  useEffect(() => {
    if (
      !!values.nric_country &&
      values.nric_country?.value === values.living_country?.value &&
      values.nric_first_level_administrative_division_id?.value ===
        values.living_first_level_administrative_division_id?.value &&
      values.nric_second_level_administrative_division_id?.value ===
        values.living_second_level_administrative_division_id?.value &&
      values.nric_third_level_administrative_division_id?.value ===
        values.living_third_level_administrative_division_id?.value &&
      values.nric_fourth_level_administrative_division_id?.value ===
        values.living_fourth_level_administrative_division_id?.value &&
      values.nric_postal_code === values.living_postal_code &&
      values.nric_address_1 === values.living_address_1 &&
      values.nric_address_2 === values.living_address_2
    ) {
      setFieldValue(name, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ToggleSwitch
      checked={values.is_same_address === true}
      onChange={handleOnChange}
    />
  )
}

export { PatientRelativeFormLivingToggleSwitch }
